module.exports = __webpack_public_path__ + "static/ocean-robbins-headshot.a6deac50.jpg";